type CloseProps = {
  className: string;
  color?: string;
};

export default function Close(props: CloseProps) {
  const color = props.color ?? "#003399";
  const className = props.className ?? "";
  return (
    <div className={className}>
      <svg
        style={{ width: "inherit", height: "inherit" }}
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.400205 16.926C0.347658 16.9261 0.295603 16.9159 0.247051 16.8958C0.198498 16.8758 0.154407 16.8463 0.117323 16.8092C0.0801295 16.7721 0.050626 16.7281 0.0304947 16.6797C0.0103634 16.6312 0 16.5793 0 16.5268C0 16.4744 0.0103634 16.4225 0.0304947 16.374C0.050626 16.3256 0.0801295 16.2816 0.117323 16.2445L15.3167 1.08103C15.3918 1.0062 15.4936 0.964172 15.5997 0.964172C15.7058 0.964172 15.8076 1.0062 15.8827 1.08103C15.9199 1.11809 15.9494 1.1621 15.9695 1.21054C15.9896 1.25898 16 1.31091 16 1.36335C16 1.4158 15.9896 1.46773 15.9695 1.51617C15.9494 1.56461 15.9199 1.60862 15.8827 1.64568L0.683535 16.8092C0.646365 16.8463 0.6022 16.8758 0.553572 16.8958C0.504944 16.9159 0.452822 16.9261 0.400205 16.926Z"
          fill={color}
        />
        <path
          d="M15.5998 16.926C15.5472 16.9261 15.4951 16.9158 15.4465 16.8958C15.398 16.8757 15.3538 16.8463 15.3167 16.8092L0.117324 1.64568C0.0801306 1.60862 0.0506267 1.56461 0.0304951 1.51617C0.0103635 1.46773 0 1.4158 0 1.36335C0 1.31091 0.0103635 1.25898 0.0304951 1.21054C0.0506267 1.1621 0.0801306 1.11809 0.117324 1.08103C0.192407 1.0062 0.294194 0.964172 0.400322 0.964172C0.50645 0.964172 0.608238 1.0062 0.683321 1.08103L15.8827 16.2445C15.9199 16.2816 15.9494 16.3256 15.9695 16.374C15.9896 16.4225 16 16.4744 16 16.5268C16 16.5793 15.9896 16.6312 15.9695 16.6797C15.9494 16.7281 15.9199 16.7721 15.8827 16.8092C15.8456 16.8463 15.8015 16.8757 15.7529 16.8958C15.7044 16.9158 15.6523 16.9261 15.5998 16.926Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
